import React from "react";
import styled from "@emotion/styled";

interface BizContainerProps {
  children: React.ReactNode;
}

const Container = styled.div`
  border-radius: 16px;
  border: 1px solid #e4e4e7;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.04), 0 4px 16px 0 rgba(0, 0, 0, 0.07);
  width: 100%;
`;

const AlertContainer = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AlertText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const InfoContainer = styled.div`
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
`;

const InfoWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 236px;
  min-width: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const BizImg = styled.img`
  border-radius: 10px;
  width: 64px;
  height: 64px;
`;

const BizPackAndShopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 56px;
  height: 56px;
  border-radius: 467px;
  background-color: #70707b;
`;

const BizPackAndShopImg = styled.img`
  width: 38px;
  height: 38px;
`;

const BottomContainer = styled.div`
  padding: 24px 0;
  display: flex;
  justify-content: flex-end;
`;

export const BizContainer: React.FC<BizContainerProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export const BizAlertContainer: React.FC<BizContainerProps> = ({ children }) => {
  return <AlertContainer>{children}</AlertContainer>;
};

export const BizInfoContainer: React.FC<BizContainerProps> = ({ children }) => {
  return <InfoContainer>{children}</InfoContainer>;
};

export const BizInfoWrap: React.FC<BizContainerProps> = ({ children }) => {
  return <InfoWrap>{children}</InfoWrap>;
};

export const BizInfo: React.FC<BizContainerProps> = ({ children }) => {
  return <Info>{children}</Info>;
};

export const BizButtonContainer: React.FC<BizContainerProps> = ({ children }) => {
  return <ButtonContainer>{children}</ButtonContainer>;
};

export const BizImage: React.FC<{ src: string; alt: string }> = ({ src, alt }) => {
  return <BizImg src={src} alt={alt} />;
};

export const BizPackAndShopImage: React.FC<{ src: string; alt: string }> = ({ src, alt }) => {
  return (
    <BizPackAndShopContainer>
      <BizPackAndShopImg src={src} alt={alt} />
    </BizPackAndShopContainer>
  );
};

export const BizBottomContainer: React.FC<BizContainerProps> = ({ children }) => {
  return <BottomContainer>{children}</BottomContainer>;
};
